module.exports = __webpack_public_path__ + "img/Pattern02.ea66b9be.png";